import { GridView } from "@mui/icons-material";
import { Outlet, useLocation } from "react-router-dom";
import HeaderTable from "../../Components/HeaderTable/HeaderTable";

const SendMail = () => {
    const location = useLocation();
    const path = location.pathname.split("/")[2];
    return (
        <>
            <HeaderTable>
                <div className="title">
                    <GridView />
                    <span> {path} </span>
                </div>
            </HeaderTable>
            <Outlet />
        </>
    );
};

export default SendMail;
